import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";

import { Alert, Button, Spin, Steps, message } from "antd";
import DisplayPrice from "../../components/common/DisplayPrice";
import { IconCopyClipboard, IconOrangeChecked } from "../../components/icons";
import { LoadingOutlined } from "@ant-design/icons";

import { getBankAccount, getOrderData } from "../../api";
import { copyToClipboard } from "../../utils/common";
import * as queryString from "query-string";

interface Props {
  handleChangeView: any;
  cancelEmbed: any;
}

const WalletBankTransfer: React.FC<Props> = ({
  handleChangeView,
  cancelEmbed,
}) => {
  const { pathname, search } = useLocation();
  const history = useHistory();
  const { t } = useTranslation(["common", "notification", "wallet"]);
  const [listBank, setListBank] = useState<any>([]);
  // const [QRData, setQRData] = useState<any>();
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  const [selectedBank, setSelectedBank] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [finalPrice, setFinalPrice] = useState<any>(0);
  const [orderCode, setOrderCode] = useState<any>("");
  const [gwTransactionId, setGwTransactionId] = useState<any>(0);
  const [paymentMethod, setPaymentMethod] = useState<string>("");

  useEffect(() => {
    const parseQuery = queryString.parse(search);

    if (parseQuery && parseQuery.finalPrice) {
      setFinalPrice(Number(parseQuery.finalPrice));
    }

    if (parseQuery && parseQuery.gwTransactionId) {
      setGwTransactionId(parseQuery.gwTransactionId);
    }

    if (parseQuery && parseQuery.orderCode) {
      setOrderCode(parseQuery.orderCode);
    }
  }, [pathname, search]);

  useEffect(() => {
    const parseQuery = queryString.parse(search);

    const fetchBankData = async () => {
      const res = await getBankAccount();
      setListBank(res.data);
      setSelectedBank(res.data[0]);
    };
    if (parseQuery?.paymentMethod === "payment_method_bank_transfer") {
      fetchBankData();
    }
  }, []);

  // get data order
  useEffect(() => {
    const fetchOrderData = async () => {
      setLoading(true);
      const parseQuery = queryString.parse(search);
      const res = await getOrderData(parseQuery.orderId);
      if (res?.status === "success") {
        const orderTransactionData = res?.data?.order_transaction_data?.[0];
        let { transaction_info } = orderTransactionData;
        setGwTransactionId(res?.data?.final_price);
        setPaymentMethod(res?.data?.payment_method);
        let transactionInfo = JSON.parse(transaction_info);
        let _selectedBank = {
          owner_name: transactionInfo?.response?.account_name,
          bank_display_name:
            transactionInfo?.response?.bank_name ||
            "Ngân hàng Thương mại cổ phần Kỹ Thương Việt Nam",
          account_number: transactionInfo?.response?.account_number,
          bank_short_name: transactionInfo?.response?.bank_short_name,
          qr_code_image: transactionInfo?.response?.qr_code_image,
        };
        setSelectedBank(_selectedBank);

        // const resListBank = await getListBankQR();
        setLoading(false);
        // if (resListBank?.statusCode === 200) {
        //   let bankQR = resListBank?.data?.find(
        //     (bank: any) =>
        //       bank?.short_name === transactionInfo?.response?.bank_short_name
        //   );
        //   console.log(transactionInfo);

        // if (bankQR) {
        //   const data = {
        //     bank: bankQR.bin,
        //     account_name: selectedBank?.owner_name,
        //     account_number: transactionInfo?.response?.account_number,
        //     amount: res?.data?.final_price,
        //     memo: parseQuery?.orderCode,
        //   };
        //   const resQR = await createBankQR(data);
        //   if (resQR.statusCode === 200) {
        //     setLoading(false);
        //     setQRData(resQR?.data);
        //   } else {
        //     setLoading(false);
        //   }
        // }
        // }
      } else {
        setLoading(false);
      }
    };

    fetchOrderData();
  }, []);

  const handleSelectBank = (bank: any) => () => {
    setSelectedBank(bank);
  };

  const handleClickCopy = (text: string) => {
    copyToClipboard(text);
    message.success("Copied to clipboard");
  };

  const handleSubmit = () => {
    const parseQuery = queryString.parse(search);

    history.push(
      pathname +
      "?" +
      queryString.stringify(
        {
          ...parseQuery,
          type: "bankTransferPending",
        },
        { skipNull: true, skipEmptyString: true }
      )
    );
    handleChangeView("bankTransferPending");
  };

  const renderIconSteps = (step: any) => {
    return <div className="iconSteps">{step}</div>;
  };

  return (
    <Spin indicator={<LoadingOutlined />} spinning={loading}>
      <div className="checkoutTransfer">
        <div className="box shadow bg-white mb-16">
          <p className="text-xl font-medium">Hướng dẫn chuyển khoản</p>
        </div>
        {paymentMethod === "payment_method_bank_transfer" && (
          <div className="checkoutTransfer__banks">
            <div className="checkoutLayout__title">
              <span>{t("common:Danh sách ngân hàng")}</span>
            </div>
            <ul className="listBank">
              {listBank.map((bank: any) => {
                return (
                  <li
                    className={`listBank__item ${selectedBank && selectedBank.id === bank.id
                        ? "active"
                        : ""
                      }`}
                    key={bank.id}
                  >
                    <button
                      type="button"
                      className="listBank__btn"
                      onClick={handleSelectBank(bank)}
                    >
                      <img src={bank.bank_icon} alt={bank.bank_short_name} />
                      <p>{bank.bank_short_name}</p>
                      <IconOrangeChecked />
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="checkoutTransfer__info">
          {/* <div className="checkoutLayout__title">
                        <span>{t('Vui lòng chuyển khoản theo thông tin')}</span>
                    </div> */}

          {paymentMethod === "payment_method_bank_transfer_new" ? (
            <Fragment>
              <Alert
                message={t(
                  "common:Vui lòng không lưu lại mã QR này để sử dụng cho các đơn hàng khác. Việc sử dụng sai mã QR có thể khiến thanh toán không được ghi nhận đúng đơn hàng"
                )}
                type="info"
                showIcon
                className="!rounded-sm"
              />
              <div className="checkoutTransfer__item shadow">
                <div className="checkoutTransfer__qr flex-col items-center  md:flex-row gap-12">
                  <div className="qrImage">
                    <img
                      src={
                        selectedBank?.qr_code_image
                          ? `data:image/png;base64,${selectedBank?.qr_code_image}`
                          : "https://statics.vntrip.vn/website/images/no-image.165x177.png"
                      }
                      alt="QR Code"
                    />
                  </div>
                  <div className="qrStep">
                    <Steps
                      direction="vertical"
                      size="small"
                      current={3}
                      items={[
                        {
                          title: t("common:Mở ứng dụng ngân hàng"),
                          icon: renderIconSteps(1),
                        },
                        {
                          title: t(
                            "common:Sử dụng chức năng chuyển tiền qua quét Qrcode"
                          ),
                          icon: renderIconSteps(2),
                        },
                        {
                          title: t("common:Thanh toán"),
                          icon: renderIconSteps(3),
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </Fragment>
          ) : (
            ""
          )}

          <div className="checkoutTransfer__item shadow">
            <div className="bankInfo">
              {selectedBank && (
                <ul className="bankInfo__list">
                  <li>
                    <p className="p1">{t("common:Ngân hàng")}:</p>
                    <p className="p2">{selectedBank.bank_display_name}</p>
                  </li>
                  <li>
                    <p className="p1">{t("common:Số tài khoản")}:</p>
                    <p className="p2">
                      {selectedBank?.account_number}
                      &nbsp;
                      <button
                        onClick={() => {
                          handleClickCopy(selectedBank?.account_number);
                        }}
                        className="btnCopy"
                      >
                        <IconCopyClipboard />
                      </button>
                    </p>
                  </li>
                  {paymentMethod === "payment_method_bank_transfer" && (
                    <li>
                      <p className="p1">{t("common:Chi nhánh")}:</p>
                      <p className="p2">{selectedBank.branch_name}</p>
                    </li>
                  )}

                  <li>
                    <p className="p1">{t("common:Chủ tài khoản")}:</p>
                    <p className="p2">{selectedBank.owner_name}</p>
                  </li>
                  <li>
                    <p className="p1">{t("common:Nội dung chuyển khoản")}:</p>
                    {orderCode && (
                      <p className="p2">
                        {orderCode}
                        &nbsp;
                        <button
                          onClick={() => {
                            handleClickCopy(orderCode);
                          }}
                          className="btnCopy"
                        >
                          <IconCopyClipboard />
                        </button>
                      </p>
                    )}
                  </li>
                </ul>
              )}
              <div className="flex flex-col md:flex-row mt-16 gap-16">
                <div className="bankInfo__price">
                  <div className="d-block">
                    <div className="p1 mb0">
                      {t("common:Số tiền cần chuyển khoản")}
                    </div>
                  </div>
                  <div className="d-block">
                    <div className="d-inline-block">
                      <p className="yellow-1 font-bold text-2xl">
                        {gwTransactionId && (
                          <div className="flex gap-8 justify-center md:justify-start items-center">
                            <DisplayPrice price={gwTransactionId} />
                            &nbsp;
                            <button
                              onClick={() => {
                                handleClickCopy(gwTransactionId);
                              }}
                              className="btnCopy pl5"
                            >
                              <IconCopyClipboard />
                            </button>
                          </div>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  loading={loadingSubmit}
                >
                  <span>{t("common:Tôi đã chuyển khoản xong")}</span>
                </Button>
              </div>

              <div className="bankInfo__note">
                <p className="red-1">
                  <strong className="pr5">{t("common:LƯU Ý")}!</strong>
                  {/* &nbsp;{t("common:Chuyển chính xác số tiền")}&nbsp;
                  <DisplayPrice price={gwTransactionId} />{" "}
                  {t("common:trong mọi trường hợp")} */}
                </p>
                <ul className="list-disc list-inside">
                  <li>
                    Chuyển CHÍNH XÁC số tiền{" "}
                    <DisplayPrice
                      price={gwTransactionId}
                      className="text-red-primary font-semibold"
                    />{" "}
                    vào số tài khoản{" "}
                    <span className="text-red-primary font-semibold">
                      {selectedBank?.account_number}
                    </span>{" "}
                    trong mọi trường hợp. Vì đây là thông tin nhận dạng duy nhất
                    để hệ thống nạp tiền tự động vào ví của bạn.
                  </li>
                  <li>
                    Vui lòng{" "}
                    <span className="text-red-primary font-semibold">
                      KHÔNG LƯU
                    </span>{" "}
                    số tài khoản do mỗi giao dịch sẽ tương ứng với số tài khoản
                    khác nhau.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default WalletBankTransfer;
